<div class="shrink-0 px-6 pt-6">
  <h1 class="headline-small text-primary text-center m-0">{{ 'Approve document' | translate }}</h1>
</div>

<app-dialog-content
  class="!pt-6"
  [class.!flex]="hideGroupAndTemplate"
  [class.!min-h-0]="hideGroupAndTemplate"
  [class.!flex-col]="hideGroupAndTemplate"
  [class.!overflow-hidden]="hideGroupAndTemplate">
  <div class="flex flex-col gap-6" [class.min-h-0]="showRecipientList">
    @if (!hideGroupAndTemplate) {
      <p class="body-medium text-on-surface-variant whitespace-pre-line mb-2">
        {{ 'Select author group and template to approve or send for review' | translate }}
      </p>
    
      <div class="flex flex-col gap-4">
        <app-select-skeleton *ngIf="isLoadingGroups"></app-select-skeleton>
        <mat-form-field *ngIf="!isLoadingGroups" appearance="outline" class="w-full" subscriptSizing="dynamic">
          <mat-label>{{ 'Author group' | translate }}</mat-label>
          <mat-select [value]="selectedGroupId" (valueChange)="onGroupChange($event)">
            <mat-option *ngFor="let g of authorGroups" [value]="g.id">{{ g.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <app-select-skeleton *ngIf="isLoadingGroups || isLoadingTemplates" [showHint]="true"></app-select-skeleton>
        <mat-form-field *ngIf="!isLoadingGroups && !isLoadingTemplates" appearance="outline" class="w-full [&_.mat-mdc-form-field-hint-wrapper]:!pl-0" subscriptSizing="dynamic">
          <mat-label>{{ 'Document type' | translate }}</mat-label>
          <mat-select [value]="selectedTemplateId" (valueChange)="selectedTemplateId = $event">
            <mat-option *ngFor="let t of documentTypes" [value]="t.id">{{ t.title }}</mat-option>
          </mat-select>
          <mat-hint class="!body-small">{{ 'Your generated content will be inserted into this template' | translate }}</mat-hint>
        </mat-form-field>
      </div>
    } @else {
      <div class="flex min-h-0 flex-auto flex-col">
        @if (showRecipientList) {
          <div
            class="flex flex-auto flex-col gap-2 overflow-y-auto"
            data-testid="approve-recipient-list">
            @if (primaryRecipient) {
              <ng-container
                *ngTemplateOutlet="recipientCard; context: { recipient: primaryRecipient, testId: 'approve-primary-recipient', isPrimary: true }">
              </ng-container>
            }
            @for (recipient of secondaryRecipients; track $index) {
              <ng-container
                *ngTemplateOutlet="recipientCard; context: { recipient: recipient, testId: 'approve-cc-recipient', isPrimary: false }">
              </ng-container>
            }
          </div>
        }
        <app-skeleton *ngIf="isLoading" class="shrink-0" [class.mt-[20px]]="showRecipientList" width="512px" height="50px" rounded="md"></app-skeleton>
        <p
          class="body-medium text-on-surface-variant shrink-0"
          [class.mt-[20px]]="showRecipientList && !isLoading"
          data-testid="approve-recipient-notice">
          {{ 'Approving this document will save it as final (no edits) and send it to the next step in your T-Pro workflow. ‘Send to editor’ sends it for review' | translate }}
        </p>
      </div>
    }

    <app-skeleton *ngIf="!hideGroupAndTemplate && isLoading" class="shrink-0" width="512px" height="50px" rounded="md"></app-skeleton>
    <div *ngIf="!isLoadingGroups && !isLoadingTemplates && authorGroups.length > 0 && alertMessage" class="flex shrink-0 items-center gap-2 rounded-md border border-outline-variant py-1 pl-3 pr-4 bg-tertiary-99 border-tertiary-50">
      <mat-icon class="text-3xl flex-shrink-0 !text-tertiary-30 material-symbols-outlined">error</mat-icon>
      <p class="label-large !font-normal text-tertiary-30">
        {{ alertMessage }}
      </p>
    </div>
  </div>
</app-dialog-content>

<ng-template #recipientCard let-recipient="recipient" let-testId="testId" let-isPrimary="isPrimary">
  <div
    class="relative flex items-start gap-2 bg-surface-bright border border-surface-container-highest rounded-lg p-4 w-full"
    [attr.data-testid]="testId">
    <div class="flex-1 min-w-0">
      <app-recipient-details [recipient]="recipient"></app-recipient-details>
    </div>
    <span
      class="shrink-0 self-start label-small text-center text-neutral-variant px-1 py-px rounded-2xl border whitespace-nowrap"
      [class.bg-primary-98]="isPrimary"
      [class.border-primary-80]="isPrimary"
      [class.bg-surface-container-lowest]="!isPrimary"
      [class.border-outline-variant]="!isPrimary"
      [attr.data-testid]="isPrimary ? 'approve-primary-badge' : 'approve-cc-badge'">
      {{ (isPrimary ? 'Primary recipient' : 'CC recipient') | translate }}
    </span>
  </div>
</ng-template>

<app-dialog-footer class="shrink-0">
  <div class="flex justify-end gap-3 w-full mt-10">
    <button
      mat-stroked-button
      color="primary"
      class="!font-light"
      (click)="close()"
      data-testid="approve-workflow-cancel">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      class="!font-light"
      (click)="submit('next')"
      [disabled]="!canSubmitToEditor"
    >
      <app-loading-spinner [loading]="isSubmitting && submittingAction === 'next'" [diameter]="20">{{ 'Send to editor' | translate }}</app-loading-spinner>
    </button>
    <button
      mat-flat-button
      color="primary"
      class="!font-light"
      (click)="submit('complete')"
      [disabled]="!canApprove"
    >
      <app-loading-spinner [loading]="isSubmitting && submittingAction === 'complete'" [diameter]="20">{{ 'Approve' | translate }}</app-loading-spinner>
    </button>
  </div>
</app-dialog-footer>


